/* global Swiper */

export default {
  init() {
    // Hero
    const globalHomepageHero = $('.global-homepage-hero');
    if (globalHomepageHero.length) {
      const swiperContainer = globalHomepageHero.find('.swiper-container').get(0);

      if (swiperContainer) {
        const autoplaySpeed = $(swiperContainer).data('autoplay-speed');
        let autoplay = false;

        if (autoplaySpeed) {
          autoplay = {
            delay: autoplaySpeed,
          };
        }

        new Swiper(swiperContainer, {
          autoplay,
          loop: true,
          effect: 'fade',
          slidesPerView: 1,
          fadeEffect: {
            crossFade: true,
          },
        });
      }
    }
  },
  finalize() {},
};



// WEBPACK FOOTER //
// ./scripts/routes/templateGlobalHomepage.js